import { TransactionType } from 'components/Order/OrderForms/OrderForm/OrderTransactionsForm/OrderTransactionsGroupForm/OrderTransactionForm/TransactionType'
import {INTERNATIONAL_TRANSPORT_TRANSACTION_SERVICE_TYPE_ID, FREIGHT_TRANSACTION_SERVICE_TYPE_ID} from 'constants/serviceTypes'

export function newTransactionFormValues (transactionType, defaultContractor) {
  return {
    transactionType,
    contractorId: defaultContractor,
    serviceTypeId: transactionType === TransactionType.Income
      ? INTERNATIONAL_TRANSPORT_TRANSACTION_SERVICE_TYPE_ID
      : FREIGHT_TRANSACTION_SERVICE_TYPE_ID,
    price: {
      amount: 0,
      currencyCode: 'EUR'
    },
    paymentDays: 30,
    comment: ''
  }
}
